import React from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./HiddenCosts.css"; // Import the CSS file

const HiddenCosts = () => {
  return (
    <FadeInSection className="hidden-costs-container">
      <h2 className="hidden-costs-title">
        What Slows Down Agent Development?
      </h2>

      <div className="hidden-costs-grid">
        {/* Column 1 */}
        <div className="hidden-costs-item">
          <img
            src={`${process.env.PUBLIC_URL}/data_challenges.svg`} 
            alt="Data Challenges" 
            className="hidden-costs-image"
          />

          <h3 className="hidden-costs-subtitle">Data Integration Challenges</h3>
          <p className="hidden-costs-text">
            Seamless data integration is key to AI success. Building complex, real-time pipelines is costly, time-consuming, and tough to scale.
          </p>
        </div>

        {/* Column 2 */}
        <div className="hidden-costs-item">
          <img
            src={`${process.env.PUBLIC_URL}/scale_challenges.svg`} 
            alt="Scale Challenges" 
            className="hidden-costs-image"
          />

          <h3 className="hidden-costs-subtitle">Operational Inefficiencies</h3>
          <p className="hidden-costs-text">
            POC AI projects might seem affordable, but they often lead to performance bottlenecks, inefficiencies, and escalating maintenance costs.
          </p>
        </div>

        {/* Column 3 */}
        <div className="hidden-costs-item">
          <img
            src={`${process.env.PUBLIC_URL}/focus_challenges.svg`} 
            alt="Focus Challenges" 
            className="hidden-costs-image"
          />

          <h3 className="hidden-costs-subtitle">Focus Drift from Growth</h3>
          <p className="hidden-costs-text">
            Managing from scratch AI systems in-house can distract from business priorities like innovation, customer growth, and revenue generation.
          </p>
        </div>
      </div>
    </FadeInSection>
  );
};

export default HiddenCosts;
